import Search from './Search'

export default {
  path: '/search',
  name: 'Search',
  component: Search
}
